import { createSlice } from "@reduxjs/toolkit";

const timerStore=createSlice({
    name:'timer',
    initialState:{
        intervalId:null,
        isRefreshing:false
    },
    reducers:{
        setTimer(state,action){
            state.intervalId=action.payload
        },
        clearTimer(state){
            if(state.intervalId){
                clearInterval(state.intervalId)
                state.intervalId = null;
            }
        },
        setIsRefreshing(state,action){
            state.isRefreshing=action.payload
        }
    }
})
export const {setTimer,clearTimer,setIsRefreshing}=timerStore.actions
const timerReducer=timerStore.reducer
export default timerReducer